export default __webpack_public_path__ + "static/media/re-weaving-indias-success-story-505x475.13bd83d3.jpg";